import { Card, Form, InputNumber } from "antd";
import React from "react";
import Field from "../../../../components/Field";
import WavelengthField from "../MPE_AEL/QuickFields/WavelengthField";
import { useTranslation } from 'react-i18next'


const FO_CWCalculator = ({ isFree = false }) => {
  const { t } = useTranslation();
  return (
    <>
      <Card style={{ margin: "24px 0 0" }} size="small" title="CW Settings">


        <WavelengthField disabled={isFree} name={['FO_cw', 'wavelength']} />


        <Field
          tabIndex={2}
          disabled={isFree}
          name={["FO_cw", "time"]}
          label={t('10077')} // Exposure Duration
          unit="s"
          placeholder={`Enter emission duration`}
          toolTipText={`The duration of continuous emission of laser radiation incident upon the human body.`}
        />

        <Field
          tabIndex={3}
          disabled={isFree}
          name={["FO_cw", "power"]}
          label={t('10078')} // Laser Power
          unit="W"
          denoms={["u", "m", false, "k", "M"]}
          placeholder={`Enter laser's output power`}
          toolTipText={`The laser's rated power expressed in watts.`}
        />
        <Form.Item
          noStyle
          shouldUpdate={(prev, curr) => prev.sourceType !== curr.sourceType} s
        >
          {({ getFieldValue }) => {
            let sourceType = getFieldValue(["sourceType"]);
            return sourceType === "singlemode" ? (
              <Field
                tabIndex={4}
                disabled={isFree}
                name={["FO_cw", "diameter"]}
                label={t('10083') /**Fiber Core Diameter*/}
                unit="m"
                denoms={["u"]}
                placeholder={`Enter Fiber Core's Diameter`}
                toolTipText={`The diameter of the source of the laser beam.`}
              />
            ) : sourceType === "multimodeSI" || "multimodeGI" ? (
              <Field
                tabIndex={4}
                disabled={isFree}
                name={["FO_cw", "numerical_aperture"]}
                label={t('10087') /** Numerical Aperture*/}
                max={1}
                placeholder={`Enter Numerical Aperture`}
                toolTipText={`The diameter of the source of the laser beam.`}
              />
            ) : null;
          }}
        </Form.Item>

        <Form.Item
          noStyle
          shouldUpdate={(prev, curr) => prev.sourceType !== curr.sourceType}
        >
          {({ getFieldValue }) => {
            let sourceType = getFieldValue(["sourceType"]);
            return sourceType === "multimodeGI" ? (
              <Field
                tabIndex={5}
                disabled={isFree}
                name={["FO_cw", "IGF"]}
                label="Index Grading Factor"
                placeholder={`Enter Index Grading Factor`}
                toolTipText={`The diameter of the source of the laser beam.`}
              />
            ) : null;
          }}
        </Form.Item>

        <Field
          tabIndex={6}
          disabled={isFree}
          name={["FO_cw", "distance"]}
          label={t('10082') /**Distance to target*/}
          unit="m"
          denoms={["k", false, "c", "m", "u", "n", "p", "f"]}
          placeholder={`Enter distance from the laser`}
          toolTipText={`The distance between the source of the laser beam and the target.`}
        />
      </Card>
    </>
  );
};

export default FO_CWCalculator;
